import React, { useEffect, useState } from 'react';

const Typewriter = ({ text, duration, startDelay = 0 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const totalCharacters = text.length;
  const interval = duration / totalCharacters;

  useEffect(() => {
    let currentCharIndex = 0;

    const startTimeout = setTimeout(() => {
      const typewriterInterval = setInterval(() => {
        setDisplayedText(text.slice(0, currentCharIndex + 1)); // Use slice to safely add characters
        currentCharIndex++;

        if (currentCharIndex >= totalCharacters) {
          clearInterval(typewriterInterval);
        }
      }, interval);

      return () => clearInterval(typewriterInterval);
    }, startDelay);

    return () => clearTimeout(startTimeout);
  }, [text, interval, totalCharacters, startDelay]);

  return <div style={{ whiteSpace: 'pre-wrap' }}>{displayedText}</div>;
};

export default Typewriter;
